import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Services from './pages/Services';
import Booking from './pages/Booking';
import Contact from './pages/Contact';
import PriceList from './pages/PriceList';
import About from './pages/About';
import Gallery from './pages/Gallery';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App font-sans-body">
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/teenused" element={<Services />} />
            <Route path="/hinnakiri" element={<PriceList />} />
            <Route path="/meist" element={<About />} />
            <Route path="/galerii" element={<Gallery />} />
            <Route path="/broneerimine" element={<Booking />} />
            <Route path="/kontakt" element={<Contact />} />
            {/* Any unknown path falls back to Home so the root always
                loads Avaleht and stale bookmarks/session state can't
                land the visitor on an interior page. */}
            <Route path="*" element={<Home />} />
          </Routes>
        </Layout>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
